import { Box, Card, CardContent, CardHeader, Divider, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MapLocation, AddLocationLink } from "src/_modules/common"
export default function MapLocationCard({
    coordinates,
    handleChange,
    locationLinkRequired = false,
    error,
    readOnlyMap = false,
    onAddressChange
}) {
    const { t } = useTranslation()
    const onAddLocation = (coords) => {
        handleChange({ target: { name: "coordinates", value: coords } })
    }
    return (
        <Card>
            <CardHeader title={t("Location Info")} />
            <Divider />
            {
                locationLinkRequired &&
                <>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <AddLocationLink handleAdd={onAddLocation} />
                            </Grid>
                        </Grid>
                    </CardContent>
                    <Divider />
                </>
            }
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Box sx={{ border: !!error ? "2px solid red" : '' }}>
                            <MapLocation
                                coordinates={coordinates}
                                handleChange={handleChange}
                                readOnlyMap={readOnlyMap}
                                onAddressChange={onAddressChange}
                                sx={{ height: '400px' }}
                            />
                        </Box>
                        {!!error && <Typography color="error">{error}</Typography>}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}